import createIcon from '../../createIcon';

/**
 * @component @name StayCurrentLandscape
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMS4wMSA3TDEgMTdDMSAxOC4xIDEuOSAxOSAzIDE5SDIxQzIyLjEgMTkgMjMgMTguMSAyMyAxN1Y3QzIzIDUuOSAyMi4xIDUgMjEgNUgzQzEuOSA1IDEuMDEgNS45IDEuMDEgN1pNMTkgN1YxN0g1VjdIMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const StayCurrentLandscape = createIcon('StayCurrentLandscape', [
  [
    'path',
    {
      d: 'M1.01 7L1 17C1 18.1 1.9 19 3 19H21C22.1 19 23 18.1 23 17V7C23 5.9 22.1 5 21 5H3C1.9 5 1.01 5.9 1.01 7ZM19 7V17H5V7H19Z',
      key: '19wuyu',
    },
  ],
]);

export default StayCurrentLandscape;
